import { Helpers } from '@app/shared/helpers';
import { BaseModel, BaseModelInterface } from '@app/abstracts';

export type SignatureRemovalRequestStatus = 'pending' | 'approved' | 'rejected';

export type SignatureRemovalRequestPeriod = 'morning' | 'afternoon';

export interface SignatureRemovalRequestInterface extends BaseModelInterface {
	_id: string;
	created_at: number | Date;
	updated_at: number | Date;
	attestation: string;
	thematique: string;
	formation: string;
	requester: string;
	stagiaire: string;
	attestation_date: number | Date;
	attestation_period: SignatureRemovalRequestPeriod;
	status: SignatureRemovalRequestStatus;
	decision_by: string | null;
	decision_at: number | Date | null;
}

export interface SignatureRemovalRequestPayload {
	attestationId: string;
}

type SignatureRemovalRequestPayloadKey = keyof SignatureRemovalRequestPayload;

export class SignatureRemovalRequest extends BaseModel<
	SignatureRemovalRequestInterface,
	SignatureRemovalRequestPayload
> {
	/** Short function to get label of instance */
	getLabel(): string {
		return this.props._id;
	}

	/** Populate the current instance from an object */
	fromObject(object: SignatureRemovalRequestInterface): void {
		this.props = Object.assign({}, object);
		this.props.created_at = Helpers.convertToDate(this.props.created_at);
		this.props.updated_at = Helpers.convertToDate(this.props.updated_at);
		this.props.attestation_date = Helpers.convertToDate(
			this.props.attestation_date
		);
		if (this.props.decision_at) {
			this.props.decision_at = Helpers.convertToDate(
				this.props.decision_at
			);
		}
		this.next();
	}

	/** Convert the current instance to an object */
	toObject(): SignatureRemovalRequestInterface {
		const props = Object.assign({}, this.props);
		props.created_at = Helpers.convertToTimestamp(props.created_at);
		props.updated_at = Helpers.convertToTimestamp(props.updated_at);
		props.attestation_date = Helpers.convertToTimestamp(
			props.attestation_date
		);
		if (props.decision_at) {
			props.decision_at = Helpers.convertToTimestamp(props.decision_at);
		}
		return props;
	}

	/** Convert an instance to an object to be sent to the API */
	toPayload(): SignatureRemovalRequestPayload {
		const raw = this.toObject();
		const payload: SignatureRemovalRequestPayload = {
			attestationId: raw.attestation
				? this.extractId(raw.attestation)
				: null,
		};
		return payload;
	}

	/** List allowed keys to be sent to the API */
	protected allowedKeys(): SignatureRemovalRequestPayloadKey[] {
		return ['attestationId'];
	}
}
